<template>
  <div class="bj-section">
    <div class="ubold-title" style="margin-bottom: 40px">邮箱认证</div>
    <div class="bj-search-section">
      <div class="bj-search-row">
        <div class="item">
          <div class="name" style="margin-right: 10px">邮箱：</div>
          <Input
            class="bj-input-26262A bj-input-h45"
            v-model="email"
            placeholder="请输入搜索的名称"
            style="width: 300px"
            clearable
          />
        </div>
        <div class="item" style="margin-left: 20px;">
          <Button
            class="bj-search-btn-F85A36"
            type="primary"
            style="margin-right: 20px;"
            @click="onSearch"
            >搜索</Button
          >
          <Button
            class="bj-border-F85A36"
            @click="onSearchCancel"
            style="margin-right: 20px"
            >重置</Button
          >
          <Button
            class="bj-border-F85A36"
            @click="addEmailModalVisibility = true"
            >添加邮箱认证</Button
          >
        </div>
      </div>
    </div>
    <div class="bj-table-data">
      <div class="total">搜索结果<span class="count">（{{ total }}）</span></div>
      <Table
        class="bj-2F3033-table"
        stripe
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="verifyStatus" slot-scope="{ row }">
          <div>
            {{ row.status | status }}
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <div v-if="row.status != 1" class="bj-rows">
            <div class="table-btn" @click="onReloadItem(row)">重新发送邮件</div>
            <div class="table-btn" @click="onDeleteItem(row)">删除</div>
          </div>
          <div v-else>--</div>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          class="pages"
          :current="page"
          :total="total"
          :page-size="limit"
          show-total
          show-sizer
          show-elevator
          @on-change="onPageChange"
          @on-page-size-change="onPageSizeChange"
        />
      </div>
    </div>
    <addEmailModal
      :show.sync="addEmailModalVisibility"
      @submit-success="onSuccess"
    ></addEmailModal>
  </div>
</template>

<script>
import {
  certifiedEmailList,
  certifiedEmailDelete,
  certifiedEmailSendEmail,
} from "api/user.js";
import addEmailModal from "components/account/addEmailModal.vue";

export default {
  name: "myEmail",
  components: {
    addEmailModal,
  },
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "认证中";
          break;
        case 1:
          title = "认证成功";
          break;
        case 2:
          title = "认证失败";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      email: "",
      page: 1,
      limit: 20,
      total: 0,
      columns: [
        {
          title: "邮箱",
          align: "center",
          key: "email",
        },
        {
          title: "提交时间",
          align: "center",
          key: "createdTime",
        },
        {
          title: "状态",
          align: "center",
          slot: "verifyStatus",
        },
        {
          title: "操作",
          width: 200,
          align: "center",
          slot: "action",
        },
      ],
      data: [],
      tableLoading: false,
      addEmailModalVisibility: false,
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        const params = {
          email: this.email,
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await certifiedEmailList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.page = val;
      this.req_getList();
    },
    // 页大小
    onPageSizeChange(val){
      this.limit = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.email = "";
      this.onPageChange(1);
    },
    // 添加认证成功
    async onSuccess(callback) {
      await this.req_getList();
      callback(true);
    },
    // 删除确认
    onDeleteItem(val) {
      this.$Modal.confirm({
        title: "删除确认",
        content: "<p>确定要删除此邮箱认证吗？</p>",
        onOk: async () => {
          const res = await certifiedEmailDelete(val.id);
          if (res.code === 200 && res.result) {
            this.$Message.success("删除成功！");
            this.req_getList();
          }
        },
      });
    },
    // 重新发送
    onReloadItem(val) {
      this.$Modal.confirm({
        title: "重发确认",
        content: "<p>确定重新发送认证邮件到</p><p>" + val.email + "？</p>",
        onOk: async () => {
          const res = await certifiedEmailSendEmail({ email: val.email });
          if (res.code === 200 && res.result) {
            this.$Message.success("操作成功！");
            this.req_getList();
          }
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
  .bj-search-section{
    background-color: #28292C;
    padding: 14px 28px;
    border-radius: 6px;
    .bj-search-row{
      display: flex;
      .item{
        display: flex;
        align-items: center;
        .name{
          color: #fff;
        }
      }
    }
  }
</style>
